export class NotificationType {

  public static SUCCESS = 'success';
  public static INFO = 'info';
  public static WARNING = 'warning';
  public static ERROR = 'error';

}
